import { useState } from "react";
import FsLightbox from "fslightbox-react";
import banner from "../../images/banner1.png";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

const Banner = () => {
  // if toggler is updated when lightbox is closed it will open it
  const [toggler, setToggler] = useState(false);
  const { t } = useTranslation();

  return (
    <>
      <FsLightbox
        toggler={toggler}
        sources={["https://www.youtube.com/watch?v=A3aQ3XqGkTo"]}
      />

      <div id="home" className="saas-banner">
        <div className="effect"></div>

        <div className="d-table">
          <div className="d-table-cell">
            <div className="container">
              <div className="saas-banner-content">
                <h1
                  data-aos="fade-up"
                  data-aos-duration="800"
                  data-aos-once="true"
                  data-aos-delay="100"
                >
                  {t("static.banners.banner1")}
                </h1>

                <p
                  data-aos="fade-up"
                  data-aos-duration="800"
                  data-aos-once="true"
                  data-aos-delay="200"
                >
                  {t("static.banners.banner2")}
                </p>

                <div
                  className="btn-box"
                  data-aos="fade-up"
                  data-aos-duration="800"
                  data-aos-once="true"
                  data-aos-delay="300"
                >
                  <a href="#contact" className="btn btn-primary">
                    {t("static.banners.getstarted")}
                  </a>

                  <div
                    onClick={() => setToggler(!toggler)}
                    className="video-btn"
                  >
                    <i className="fab fa-google-play"></i> {t("static.banners.watch")}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="saas-banner-image"
          data-aos="fade-up"
          data-aos-duration="800"
          data-aos-once="true"
          data-aos-delay="500"
        >
          <img
            src={banner}
            alt="laptop"
            style={{ maxWidth: "850px", width: "80%", height: "auto" }}
          />
        </div>
      </div>
    </>
  );
};

export default Banner;
